import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LS_KEY = "halalgo_maintenance";

const readCache = () => {
  try {
    const c = localStorage.getItem(LS_KEY);
    return c ? JSON.parse(c) : null;
  } catch (e) {
    return null;
  }
};

// Reads platform maintenance status from the LOCAL backend. Seeds from a cached
// value so returning visitors render instantly, then reconciles in the
// background. Falls back to the cache (or "live") if the request fails so the
// public site never gets stuck.
export function useMaintenance() {
  const [status, setStatus] = useState(readCache);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/settings/maintenance`, { timeout: 4000 });
      setStatus(res.data);
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(res.data));
      } catch (e) {
        /* ignore quota errors */
      }
      return res.data;
    } catch (e) {
      const cached = readCache();
      const fallback = cached || { maintenance_mode: false };
      setStatus(fallback);
      return fallback;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { status, loading, refresh: load };
}
